import { SrOnly as InternalSrOnly } from "../../internal";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
 * There are occasional instances where content should be made available to
 * screen reader users but hidden from sighted users. In the vast majority
 * cases, content that is available visually should be available to screen
 * reader users, and vice versa. Verbose cues or instructions that are only read
 * by screen reader users usually do more harm than good. However, there are a
 * few cases where information or meaning is apparent visually but may not be
 * apparent to screen reader users. In these rare cases, it may be appropriate
 * to cause content to be read by a screen reader, but have the content remain
 * invisible to sighted users.
 *
 * In these cases you can use this SrOnly component to only expose text to
 * screen reader users.  Keep in mind there may be other available techniques in
 * some situations, such as using `aria-label`.  The main drawback of
 * `aria-label` is that it can't be used on a role-less element
 *
 * @see https://webaim.org/techniques/css/invisiblecontent/
 */
export function SrOnly(_ref) {
  var children = _ref.children,
    id = _ref.id;
  return _jsx(InternalSrOnly, {
    id: id,
    children: children
  });
}